module.exports = function getResource(label, vars = []) {
    let resources = {
        add: 'Add',
        new: 'New'
    };
    return resources[label];
};
